module.exports = __webpack_public_path__ + "static/media/MoreVertical.26162592.svg";